import Vue from 'vue';
import Router from 'vue-router';

import nav_gaurd from './nav_gaurd.js';

import PageNotFound from './views/PageNotFound.vue';

import store from '@/store'
import module_auth from '@/modules/auth';
import module_onboarding from '@/modules/onboarding';
import module_payroll from '@/modules/payroll'
import module_dashboard from '@/modules/dashboard'

Vue.use(Router);

const routes = [
  ...module_auth.routes,
  ...module_onboarding.routes,
  ...module_payroll.routes,
  ...module_dashboard.routes,
  {
    path: '/PageNotFound',
    name: 'PageNotFound',
    component: PageNotFound
  },
  {
      path: '*',
      redirect: '/PageNotFound'
    },
];

const router = new Router({
  mode: "history",
  routes
});

router.beforeEach(nav_gaurd);

//only logging right now
store.watch(function(state){
  return state.auth.auth_token
},function(){
  // handle isAuth
  if(store.getters['auth/isAuth']){
    //console.log('[Watch State/Auth/IsAuth] Logged in');
  }else{
    //console.log('[Watch State/Auth/IsAuth] Logged Out');
  }
})

export default router;
